Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Replit = void 0;
var _react = _interopRequireDefault(require("react"));
var _generalObserver = require("../general-observer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Replit = function Replit(_ref) {
  var repl = _ref.repl,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 500 : _ref$height,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'embed' : _ref$mode;
  var url = repl.startsWith('http') ? repl : "https://repl.it/".concat(repl);
  var query = mode === 'embed' ? '?embed=true' : '?lite=true';
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, {
    height: height
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    "data-testid": 'replit-' + mode,
    frameBorder: "0",
    width: "100%",
    height: height,
    src: url + query
  }));
};
exports.Replit = Replit;